import React from 'react';
import DetailLayout from '@layouts/DetailLayout/DetailLayout';
import { type To, useNavigate } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { CreateUserForm } from '../CreateUserForm/CreateUserForm';

import './CreateUserPage.scss';

export const CreateUserPage: React.FC = () => {
  const navigate = useNavigate();
  const breadcrumbs = useBreadcrumbs();
  let prevLink = breadcrumbs.at(-2)?.key as unknown;
  if (!prevLink) prevLink = -1;

  return (
    <DetailLayout title="Добавление пользователя" className="new-user" showFooter>
      <CreateUserForm
        onClose={() => {
          navigate(prevLink as To);
        }}
      />
    </DetailLayout>
  );
};
